export const typography = {
  sizes: {
    h6: '1.25rem'
  }
};